import React from 'react';
import PropTypes from 'prop-types';
import { Card as MuiCard, CardHeader, CardContent } from '@mui/material';

/**
 * Shell card for any Recharts/Nivo component with consistent padding + elevation.
 * Children receives full height so the parent Row/Col should set explicit height.
 */
export default function ChartCard ({ title, action, children, elevation = 3 }) {
  return (
    <MuiCard elevation={elevation} sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardHeader title={title} action={action} sx={{ pb: 0 }} />
      <CardContent sx={{ flexGrow: 1 }}>
        {children}
      </CardContent>
    </MuiCard>
  );
}

ChartCard.propTypes = {
  title: PropTypes.string.isRequired,
  action: PropTypes.node,
  children: PropTypes.node.isRequired,
  elevation: PropTypes.number,
};
